function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "mist"
}, React.createElement("path", {
  id: "Vector",
  d: "M42.667 119.733H315.734C320.453 119.733 324.267 115.91 324.267 111.2C324.267 106.49 320.453 102.667 315.734 102.667H42.667C37.948 102.667 34.134 106.49 34.134 111.2C34.134 115.91 37.948 119.733 42.667 119.733Z",
  fill: "white"
}), React.createElement("path", {
  id: "Vector_2",
  d: "M247.467 205.067H59.733C55.014 205.067 51.2 208.89 51.2 213.6C51.2 218.31 55.014 222.133 59.733 222.133H247.466C252.185 222.133 255.999 218.31 255.999 213.6C256 208.89 252.186 205.067 247.467 205.067Z",
  fill: "white"
}), React.createElement("path", {
  id: "Vector_3",
  d: "M119.467 162.4C119.467 157.69 115.653 153.867 110.934 153.867H8.533C3.814 153.867 0 157.69 0 162.4C0 167.11 3.814 170.933 8.533 170.933H110.933C115.652 170.933 119.467 167.11 119.467 162.4Z",
  fill: "white"
}), React.createElement("path", {
  id: "Vector_4",
  d: "M93.867 68.533H213.334C218.053 68.533 221.867 64.71 221.867 60C221.867 55.29 218.053 51.467 213.334 51.467H93.867C89.148 51.467 85.334 55.29 85.334 60C85.333 64.71 89.148 68.533 93.867 68.533Z",
  fill: "white"
}), React.createElement("path", {
  id: "Vector_5",
  d: "M238.933 60C238.933 64.71 242.747 68.533 247.466 68.533H435.2C439.919 68.533 443.733 64.71 443.733 60C443.733 55.29 439.919 51.467 435.2 51.467H247.467C242.748 51.467 238.933 55.29 238.933 60Z",
  fill: "white"
}), React.createElement("path", {
  id: "Vector_6",
  d: "M349.867 102.667C345.148 102.667 341.334 106.49 341.334 111.2C341.334 115.91 345.148 119.733 349.867 119.733H418.134C422.853 119.733 426.667 115.91 426.667 111.2C426.667 106.49 422.853 102.667 418.134 102.667H349.867Z",
  fill: "white"
}), React.createElement("path", {
  id: "Vector_7",
  d: "M179.2 17.333H401.067C405.786 17.333 409.6 13.51 409.6 8.8C409.6 4.09 405.786 0.266998 401.067 0.266998H179.2C174.481 0.266998 170.667 4.09 170.667 8.8C170.667 13.51 174.481 17.333 179.2 17.333Z",
  fill: "white"
}), React.createElement("path", {
  id: "Vector_8",
  d: "M469.333 205.067H281.6C276.881 205.067 273.067 208.89 273.067 213.6C273.067 218.31 276.881 222.133 281.6 222.133H469.333C474.052 222.133 477.866 218.31 477.866 213.6C477.867 208.89 474.052 205.067 469.333 205.067Z",
  fill: "white"
}), React.createElement("path", {
  id: "Vector_9",
  d: "M418.133 307.467H247.467C242.748 307.467 238.934 311.29 238.934 316C238.934 320.71 242.748 324.533 247.467 324.533H418.134C422.853 324.533 426.667 320.71 426.667 316C426.667 311.29 422.852 307.467 418.133 307.467Z",
  fill: "white"
}), React.createElement("path", {
  id: "Vector_10",
  d: "M366.933 358.667H145.067C140.348 358.667 136.534 362.49 136.534 367.2C136.534 371.91 140.348 375.733 145.067 375.733H366.934C371.653 375.733 375.467 371.91 375.467 367.2C375.467 362.49 371.652 358.667 366.933 358.667Z",
  fill: "white"
}), React.createElement("path", {
  id: "Vector_11",
  d: "M503.467 153.867H145.067C140.348 153.867 136.534 157.69 136.534 162.4C136.534 167.11 140.348 170.933 145.067 170.933H503.467C508.186 170.933 512 167.11 512 162.4C512 157.69 508.186 153.867 503.467 153.867Z",
  fill: "white"
}), React.createElement("path", {
  id: "Vector_12",
  d: "M93.867 256.267C89.148 256.267 85.334 260.09 85.334 264.8C85.334 269.51 89.148 273.333 93.867 273.333H162.134C166.853 273.333 170.667 269.51 170.667 264.8C170.667 260.09 166.853 256.267 162.134 256.267H93.867Z",
  fill: "white"
}), React.createElement("path", {
  id: "Vector_13",
  d: "M221.867 316C221.867 311.29 218.053 307.467 213.334 307.467H59.734C55.015 307.467 51.201 311.29 51.201 316C51.201 320.71 55.015 324.533 59.734 324.533H213.334C218.052 324.533 221.867 320.71 221.867 316Z",
  fill: "white"
}), React.createElement("path", {
  id: "Vector_14",
  d: "M187.733 264.8C187.733 269.51 191.547 273.333 196.266 273.333H384C388.719 273.333 392.533 269.51 392.533 264.8C392.533 260.09 388.719 256.267 384 256.267H196.267C191.548 256.267 187.733 260.09 187.733 264.8Z",
  fill: "white"
}));

var SvgMist = function SvgMist(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 512,
    height: 376,
    viewBox: "0 0 512 376",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMist, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mist.5292335d.svg";
export { ForwardRef as ReactComponent };